var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"title":"Số lượng Giảng viên và Lớp độc lập"}},[_c('app-echart-bar',{attrs:{"option-data":_vm.createClassesAndEmployeesByDepartmentEchartBar}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }